export default __webpack_public_path__ + "static/media/appdev.87e248ec.png";